import { render, staticRenderFns } from "./ConfirmRecharge.vue?vue&type=template&id=70d35a80&"
import script from "./ConfirmRecharge.vue?vue&type=script&lang=js&"
export * from "./ConfirmRecharge.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRecharge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports